import "./index.css";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Layout from "./componets/Layout";
import Home from "./pages/Home";
import Shopify from "./pages/Shopify";
import Shopify_ny from "./pages/Shopify-ny";
import Shopify_Texas from "./pages/Shopify-Texas";
import Magento from "./pages/Magento";
import BigCommerce from "./pages/BigCommerce";
import WooCommerce from "./pages/WooCommerce";
import WordpressDevelopment from "./pages/WordpressDevelopment";
import MobileAppDevelopment from "./pages/MobileAppDevelopment";
import GameDesignAndDevelopment from "./pages/GameDesignAndDevelopment";
import Erp from "./pages/Erp";
import HostingAndCloudServices from "./pages/HostingAndCloudServices";
import PluginAndAppDevelopment from "./pages/PluginAndAppDevelopment";
import PerformanceMarketing from "./pages/PerformanceMarketing";
import PerformanceMarketing_ny from "./pages/PerformanceMarketing-ny";
import PerformanceMarketing_Texas from "./pages/PerformanceMarketing-Texas";
import Tiktok from "./pages/Tiktok";
import Seo from "./pages/Seo";
import Seo_ny from "./pages/Seo_ny";
import Seo_Texas from "./pages/Seo-Texas";
import InfluencerMarketing from "./pages/InfluencerMarketing";
import SocialMediaMarketing from "./pages/SocialMediaMarketing";
import ConversionRateOptimization from "./pages/Conversion-rate-optimization";
import EmailMarketing from "./pages/EmailMarketing";
import LogoAndBranding from "./pages/LogoAndBranding";
import PrintDesignAndService from "./pages/PrintDesignAndService";
import ProductAndMerchandise from "./pages/ProductAndMerchandise";
import BannersAndAdvertisement from "./pages/Banners-and-advertisement";
import UiAndUxDesign from "./pages/UiAndUxDesign";
import StaffAugmentationService from "./pages/StaffAugmentationService";
import ProjectOutsourcing from "./pages/ProjectOutsourcing";
import CctvSurveillance from "./pages/CcctvSurveillance";
import AiInEcommerce from "./pages/AiInEcommerce";
import VirtualAssistant from "./pages/VirtualAssistant";
import Clients from "./pages/Clients";
import Testimonial from "./pages/Testimonial";
import Blogs from "./pages/Blogs";
import Career from "./pages/Career";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import Faq from "./pages/Faq";
import News from "./pages/News";
import InfluencerRegistrationForm from "./pages/InfluencerRegistrationForm";
import Media from "./pages/OurGallery";
import BlogDetails from "./pages/BlogDetails";
import WebDevelopment from "./pages/Web-Developement"
import WebDevelopment_ny from "./pages/Web-Developement-ny"
import WebDevelopment_Texas from "./pages/Web-Developement-texas"
import { ToastContainer } from "react-toastify";
import CaseStudies from "./pages/CaseStudies";
import CaseStudyDetail from "./pages/CaseStudyDetail";
import MBGPage from "./pages/MBGPage";
import ShopifyPlus from "./pages/ShopifyPlus";
import ShopifyPlus_ny from "./pages/ShopifyPlus_ny";
import ShopifyPlus_Texas from "./pages/ShopifyPlus-Texas";
import PrivacyPolicy from "./pages/PrivacyPolicy/CsVgo";
import PrivacyPolicy1 from "./pages/PrivacyPolicy/UrbanPick";
import OFSBackSortPrivacyPolicy from "./pages/PrivacyPolicy/Ofs";
import SmartStockPrivacyPolicy from "./pages/PrivacyPolicy/smart-stock";
import EmployeeDiscountPrivacyPolicy from "./pages/PrivacyPolicy/EmployeeDiscountPrivacyPolicy";
import SmartCampaignPrivacyPolicy from "./pages/PrivacyPolicy/SmartCampaignPrivacyPolicy";
import EoceanPrivacyPolicy from "./pages/PrivacyPolicy/EoceanPrivacyPolicy";
import BulkGiftPrivacyPolicy from "./pages/PrivacyPolicy/BulkGift";
import PingMePrivacyPolicy from "./pages/PrivacyPolicy/PingMe";
import UserProfilePage from "./pages/UserProfile/UserProfilePage";
import Canonical from "./componets/CanonicalTag";
import NotFound from "./componets/NotFound";
import WebNewYorkPage from "./pages/WebNewYorkPage";
import ThankYou from "./pages/ThankYou";


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ToastContainer position="top-center" autoClose={3000} />
        <Canonical />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/shopify-website-development" element={<Shopify />} />
            <Route path="/shopify-website-development-ny" element={<Shopify_ny />} />
            <Route path="/shopify-website-development-Texas" element={<Shopify_Texas />} />
            <Route path="/shopify-plus-development" element={<ShopifyPlus />} />
            <Route path="/shopify-plus-development-ny" element={<ShopifyPlus_ny />} />
             <Route path="/shopify-plus-development-Texas" element={<ShopifyPlus_Texas />} />
            {/* <Route path="/shopify-plus-development" element={<ShopifyPlus plus={true} />} /> */}
            <Route path="/magento-website-development" element={<Magento />} />
            <Route path="/bigcommerce-development-services" element={<BigCommerce />} />
            <Route path="/woocommerce-development-services" element={<WooCommerce />} />
            <Route path="/website-design-and-development" element={<WebDevelopment />} />
            <Route path="/website-design-and-development-ny" element={<WebDevelopment_ny />} />
            <Route path="/website-design-and-development-Texas" element={<WebDevelopment_Texas />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/case-study/:title" element={<CaseStudyDetail />} />
            <Route path="/case-study/mbg" element={<MBGPage />} />
            <Route path="/wordpress-web-development" element={<WordpressDevelopment />} />
            <Route path="/mobile-application-development-services" element={<MobileAppDevelopment />} />
            <Route path="/game-design-and-development" element={<GameDesignAndDevelopment />} />
            <Route path="/erp" element={<Erp />} />
            <Route path="/hosting-cloud-services" element={<HostingAndCloudServices />} />
            <Route path="/custom-plugin-app-development" element={<PluginAndAppDevelopment />} />
            <Route path="/performance-marketing" element={<PerformanceMarketing />} />
            <Route path="/performance-marketing_ny" element={<PerformanceMarketing_ny />} />
            <Route path="/performance-marketing-Texas" element={<PerformanceMarketing_Texas />} />
            <Route path="/tiktok-marketing-services" element={<Tiktok />} />
            <Route path="/search-engine-optimization-services" element={<Seo />} />
            <Route path="/search-engine-optimization-services-ny" element={<Seo_ny />} />
            <Route path="/search-engine-optimization-services-Texas" element={<Seo_Texas />} />
            <Route path="/influencer-marketing-services" element={<InfluencerMarketing />} />
            <Route path="/digital-marketing-services" element={<SocialMediaMarketing />} />
            <Route path="/email-marketing-services" element={<EmailMarketing />} />
            <Route path="/conversion-rate-optimization-services" element={<ConversionRateOptimization />} />
            <Route path="/logo-branding-services" element={<LogoAndBranding />} />
            <Route path="/graphic-designing-services" element={<PrintDesignAndService />} />
            <Route path="/product-merchandise" element={<ProductAndMerchandise />} />
            <Route path="/Banners-and-advertisement" element={<BannersAndAdvertisement />} />
            <Route path="/ui-ux-design-services" element={<UiAndUxDesign />} />
            <Route path="/staff-augmentation-service" element={<StaffAugmentationService />} />
            <Route path="/project-outsourcing" element={<ProjectOutsourcing />} />
            <Route path="/cctv" element={<CctvSurveillance />} />
            <Route path="/ai-in-ecommerce" element={<AiInEcommerce />} />
            <Route path="/virtual-assistant" element={<VirtualAssistant />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/testimonial" element={<Testimonial />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogs/:handle" element={<BlogDetails />} />
            <Route path="/career" element={<Career />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact-mean3" element={<ContactUs />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/news-and-pr" element={<News />} />
            <Route path="/influencer-registration-form" element={<InfluencerRegistrationForm />} />
            <Route path="/media" element={<Media />} />
            <Route path="/csvgo-privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/urban-pick-privacy-policy" element={<PrivacyPolicy1 />} />
            <Route path="/ofs-backsort-privacy-policy" element={<OFSBackSortPrivacyPolicy />} />
            <Route path="/privacy-policy-smart-stock" element={<SmartStockPrivacyPolicy />} />
            <Route path="/privacy-policy-smart-campaign" element={<SmartCampaignPrivacyPolicy />} />
            <Route path="/privacy-policy-employee-discount" element={<EmployeeDiscountPrivacyPolicy />} />
            <Route path="/privacy-policy-eoceanapp" element={<EoceanPrivacyPolicy />} />
            <Route path="/bulk-gift-privacy-policy" element={<BulkGiftPrivacyPolicy />} />
            <Route path="/pingme-backinstock-privacy-policy" element={<PingMePrivacyPolicy />} />
            <Route path="/author/:username" element={<UserProfilePage />} />
            <Route path="/nyc" element={<WebNewYorkPage />} />
            {/* 404 catch-all route */}
            <Route path="*" element={<NotFound />} />
            <Route path="/thank-you" element={<ThankYou />} />



          </Route>
        </Routes>
      </BrowserRouter>
      <div className="backtotop">
        <a href="#" id="totop" class="u-trans-all-2s js-scroll-event on--totop flex items-center flex-col" data-forch="300" data-visibleclass="on--totop">
          <svg xmlns="http://www.w3.org/2000/svg" class="my-svg" width="13" height="10" viewBox="0 0 9 6" fill="none"><path d="M3.92877 5.1729L0.580521 1.82465C0.463038 1.70716 0.404297 1.5666 0.404297 1.40297C0.404297 1.23933 0.463038 1.10297 0.580521 0.993876L1.13437 0.427443C1.25185 0.318352 1.39241 0.263806 1.55605 0.263806C1.71968 0.263806 1.85605 0.318352 1.96514 0.427443L4.34416 2.80646L6.71059 0.427443C6.82807 0.318352 6.96863 0.263806 7.13227 0.263806C7.29591 0.263806 7.43227 0.318352 7.54136 0.427443L8.10779 0.993876C8.21688 1.10297 8.27143 1.23933 8.27143 1.40297C8.27143 1.5666 8.21688 1.70716 8.10779 1.82465L4.75954 5.1729C4.64206 5.29038 4.5015 5.34912 4.33786 5.34912C4.17423 5.34912 4.03786 5.29038 3.92877 5.1729Z" fill="#999999"></path></svg>
          TOP</a>
      </div>
      <div className="whatsapp">
        <a href="https://api.whatsapp.com/send?phone=18322782928" class="float-wa" target="_blank"> <img class="my-float" src="./assets/uploads/2023/11/whatsapp-icon-1.webp" /> </a>
      </div>
    </div>
  );
}

export default App;
